/**
 * @file 开始使用页老文档
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import useOldDocHooks from './oldDocHooks';
import DocMarkdownContainer from '../../components/doc-container/DocMarkdownContainer';

const OldDoc: React.FC = () => {
    const {
        quickInstallDetail
    } = useOldDocHooks();

    return (
        <div className="paddle-install-page-subcontainer">
            <div className="paddle-install-old-detail-wrap">
                <DocMarkdownContainer
                    text={quickInstallDetail}
                />
            </div>
        </div>
    );
};

export default OldDoc;
